import { Config } from "../../config";

export const SESSION_ENDED_STORAGE_KEY = "sessionEnded";

const config = new Config();

export const hasSessionEnded = (): boolean =>
  sessionStorage.getItem(SESSION_ENDED_STORAGE_KEY) === "true";

export const markSessionEnded = (): void => {
  sessionStorage.setItem(SESSION_ENDED_STORAGE_KEY, "true");
};

export const getAgentEndUrl = (version: string = ""): string => {
  const path =
    version === "v1" ? "agent_end/" : "candidate/chatbot/end";
  return `${config.settings.AgentApiUrl}${path}`;
};

/**
 * Standard JSON POST (same as axios endAgentChat), with keepalive so the
 * request can finish when the tab/window is closing.
 */
export const sendAgentEndOnUnload = (
  requestId: string,
  version: string = "",
): boolean => {
  if (!requestId || hasSessionEnded()) {
    return false;
  }

  markSessionEnded();

  const url = getAgentEndUrl(version);

  try {
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ request_id: requestId }),
      keepalive: true,
    });
    return true;
  } catch {
    return false;
  }
};
